import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-cloud",
  templateUrl: "./med-icon-cloud.component.html",
})
export class MedIconCloudComponent extends SvgMixinComponent {}
